import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=631358bd&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=631358bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../code/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631358bd",
  null
  
)

export default component.exports